export default {
  columns: 'Columns',
  hasTotal: 'Total',
  addColumn: 'Add column',
  unknownAttribute: 'Deleted attribute',
};
